import { gql } from "@apollo/client";

export const GET_DESIGN_REVIEW_NOTIFICATIONS = gql`
  query GetDesignReviewNotifications(
    $take: Int
    $skip: Int
    $showRead: Boolean
  ) {
    getDesignReviewNotifications(
      take: $take
      skip: $skip
      showRead: $showRead
    ) {
      notifications {
        id
        orderDesignId
        orderId
        orderReference
        patientName
        status
        doctorName
        providerName
        isRead
        createdAt
      }
      totalCount
    }
  }
`;

export const MARK_DESIGN_REVIEW_NOTIFICATION_AS_READ = gql`
  mutation MarkDesignReviewNotificationAsRead($id: String!) {
    markDesignReviewNotificationAsRead(id: $id)
  }
`;

export const MARK_DESIGN_REVIEW_NOTIFICATION_AS_UNREAD = gql`
  mutation MarkDesignReviewNotificationAsUnread($id: String!) {
    markDesignReviewNotificationAsUnread(id: $id)
  }
`;
